/// <reference path="./globals.d.ts" />

/*
[WBLS-CART] -- v1.1.02

dev notes for v2.0.0:
- TO DO: discounts
- TO DO: helper functions in global object 
  - proteus.cart.add_item()
  - proteus.cart.add_item()
  - proteus.cart.add_item()

*/

let progress_thresholds = [
  {
  threshold_USD: 5000,
  message: "FREE SHIPPING",
  label: "free shipping<br>(U.S. only)",
  var_ids: []
}
];
window.js_cart_incentives = progress_thresholds; 

// assuming free shipping is the first threshold
let free_shipping_threshold = js_cart_incentives[0].threshold_USD;

window.active_currency_conversion_rate = 1;
window.active_currency = "USD";

if(window.location.href.indexOf("/en-ca") > -1){
  window.active_currency = "CAD"
  window.active_currency_conversion_rate = 1.35;
}

window.build_qualifying_items = () => {

  window.gwp_qualifying_items = [];

  for(i = 0; i < window.js_cart_incentives.length; i++){
    // adjust thresholds for conversion rate
    window.js_cart_incentives[i].threshold_USD = window.js_cart_incentives[i].threshold_USD * window.active_currency_conversion_rate;
  
    if(js_cart_incentives[i].var_id != "none"){
      console.log("map GWP item", js_cart_incentives[i].var_id)
  
      // lookup and map GWP item if it exists
      for(let ii = 0; ii < window.hidden_products.length; ii++){
        
        if(window.hidden_products[ii].var_id == js_cart_incentives[i].var_id){
          window.gwp_qualifying_items.push({
            handle: "none",
            var_id: "none",
            threshold: js_cart_incentives[i].threshold_USD,
            gwp_id: ii
          });
          break;
        }
        
      }
    }
    
  }
  
};

// init;
window.build_qualifying_items();

if(window.location.href.indexOf("?qa=stickers_gwp") > -1 || false){
  window.sessionStorage.setItem("woobles_sticker_pack_gwp", true) 
}

let current_cart_count = 0;
let added_quantity = 0;

const retrieve_cart_data = () => {
  console.log("retrieve_cart_data()");

  return Woobles.Sentry.startSpan({ name: 'Retrieve Cart Data' }, async () => {
    try {
      Woobles.Sentry.addInfoBreadcrumb({
        message: 'Retrieving cart data'
      })

      const response = await fetch('/cart.js')

      if (response.ok) {
        const cart = await response.json()

        window.active_currency = cart.currency;

        let cart_data = {
          cart_attributes: cart.attributes,
          cart_currency: cart.currency,
          cart_item_count: cart.item_count,
          cart_line_items: cart.items,
          cart_original_price: cart.original_total_price,
          cart_subtotal: cart.items_subtotal_price,
          cart_total_discount: cart.total_discount,
          cart_total_price: cart.total_price,
          //cart_total_shipping: cart.total_shipping,
        };

        Woobles.Sentry.addBreadcrumb({
          message: 'Cart retrieved',
          data: {
            response: cart
          }
        })

        // console.log(cart.items_subtotal_price);

        if(JSON.stringify(cart_data) != window.sessionStorage.getItem("local-cart-data")){
          console.log("CHANGES TO CART - UPDATE LOCAL CART DATA");
          window.sessionStorage.setItem("local-cart-data", JSON.stringify(cart_data));
          js_cart_build_line_items();

          // send cart data to Klaviyo (function defined in theme)
          kl_tracking_atc(cart);

        } else {
          console.log("NO CHANGES - PRESERVE LOCAL CART DATA");
        }

        // Check to see if items were added to cart and assert whether the new quantity matches what is returned
        // from the cart
        if (added_quantity > 0) {
          if (current_cart_count + added_quantity !== cart.item_count) {
            Woobles.Sentry.addErrorBreadcrumb({
              message: `${added_quantity} items were added to cart which had ${current_cart_count} in it, but only ${cart.item_count} are in the cart now`,
              data: {
                cart: cart
              }
            })
            Woobles.Sentry.captureException(new Error('Cart item count does not match expected value'));
          }

          added_quantity = 0
        }

        current_cart_count = cart.item_count;

        return cart
      } else {
        Woobles.Sentry.captureException(new Error('Cannot retrieve cart data'));
      }
    } catch (error) {
      Woobles.Sentry.captureException(error);
      console.error('Error fetching cart:', error);
    }
  })
};

const add_to_cart = (var_id, qty = 1, line_item_properties) => {
  const body = {
    id: parseInt(var_id),
    quantity: qty,
    properties: line_item_properties
  }

  return Woobles.Sentry.startSpan({ name: 'Add to Cart' }, async () => {
    try {
      Woobles.Sentry.addInfoBreadcrumb({
        message: 'Adding item to cart',
        data: {
          payload: body
        }
      })

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      })

      if (response.ok) {

        const data = await response.json()

        console.log('Item added to cart:', data);

        Woobles.Sentry.addBreadcrumb({
          message: 'Item added to cart',
          data: {
            payload: body,
            response: data
          }
        })

        retrieve_cart_data();

        // open cart
        open_js_cart();

        added_quantity = qty;

        return data
      } else {
        Woobles.Sentry.captureException(new Error('Cannot add item to cart'))
      }
    } catch (error) {
      Woobles.Sentry.captureException(error);
      console.error('Error adding item to cart:', error);
    }
  })
};

observeSelector('.js-cart--close', js_cart_close => {
  js_cart_close.addEventListener("click", () => {
    close_js_cart();
    Woobles.Sentry.addClickBreadcrumb({
      message: 'Cart closed - .js-cart--close',
      data: {
        html: js_cart_close.outerHTML
      }
    })
  })
});

observeSelector('[href="/cart"]', js_cart_open => {
  js_cart_open.addEventListener("click", (e) => {
    e.preventDefault();
    Woobles.Sentry.addClickBreadcrumb({
      message: 'Cart opened - [href="/cart"]',
      data: {
        html: js_cart_open.outerHTML
      }
    })
    open_js_cart();
  })
});

const js_cart_incentives_html = `
<div class="js-incentives">
  <div class="js-incentives--message">...</div>
  <div class="js-incentives--bar">
    <div class="js-incentives--bar--filled"></div>
    
    <div class="js-incentives--goals"></div>

  </div>
</div>
`;

const js_cart_update_progress_bar = (subtotal) => {
  console.log("update_progress_bar()");

  waitForElement('.js-cart--progress-bar').then(progress_bar => {

    console.log("...COMPARING...", document.querySelectorAll('.js-incentives--threshold').length, window.js_cart_incentives.length)
    if(document.querySelectorAll('.js-incentives--threshold').length != window.js_cart_incentives.length){
      // remove and let it rebuild
      progress_bar.querySelector('.js-incentives--goals').innerHTML = "";
    }

    progress_bar.setAttribute(`data-cart-subtotal`, subtotal);

    // add incentives markup if it doesn't exist
    if(js_cart_incentives.length > 0 && progress_bar.querySelectorAll('.js-incentives--threshold').length == 0){
      for(let i = 0; i < js_cart_incentives.length; i++){
        progress_bar.querySelector('.js-incentives--goals').insertAdjacentHTML("beforeend", `
        <!--
        <div class="js-incentives--threshold js-tease js-reveal" 
        data-threshold="${js_cart_incentives[i].threshold_USD}" 
        data-var-id="${js_cart_incentives[i].var_id}" 
        style="left: ${(1 / js_cart_incentives.length * 100) * (i + 1)}%;" 
        data-label="${js_cart_incentives[i].message}">
        -->
        <div class="js-incentives--threshold js-tease js-reveal" 
        data-threshold="${js_cart_incentives[i].threshold_USD}" 
        data-var-id="${js_cart_incentives[i].var_id}" 
        style="left: ${(i + 1) / js_cart_incentives.length * 100}%;" 
        data-label="${js_cart_incentives[i].message}">
        
          <div class="js-incentives--threshold--dot">
            <div class="js-incentives--threshold--dot--icon">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="800px" width="800px" version="1.1" id="Capa_1" viewBox="0 0 17.837 17.837" xml:space="preserve"><g><path d="M16.145,2.571c-0.272-0.273-0.718-0.273-0.99,0L6.92,10.804l-4.241-4.27   c-0.272-0.274-0.715-0.274-0.989,0L0.204,8.019c-0.272,0.271-0.272,0.717,0,0.99l6.217,6.258c0.272,0.271,0.715,0.271,0.99,0   L17.63,5.047c0.276-0.273,0.276-0.72,0-0.994L16.145,2.571z"></path></g></svg>
            </div>
          </div>
          <div class="js-incentives--threshold--label">${js_cart_incentives[i].label}</div>
        </div>
        `);
        
        progress_bar.setAttribute(`data-threshold-${i + 1}`, js_cart_incentives[i].threshold_USD);
        if(i == js_cart_incentives.length - 1){
          progress_bar.setAttribute(`data-max-threshold`, js_cart_incentives[i].threshold_USD);
        }

      }
    } 

    // update progress
    waitUntil(() => {
      return progress_bar.querySelectorAll('.js-incentives--threshold').length > 0;
    }).then(() => {

      // console.log("SUBTOTAL IS", subtotal);

      let bar = progress_bar.querySelector('.js-incentives--bar--filled');
      let message = progress_bar.querySelector('.js-incentives--message');
      let max_threshold = parseInt(progress_bar.getAttribute('data-max-threshold'));
      let threshold_items = progress_bar.querySelectorAll('.js-incentives--threshold');

      let incentives_message_html;
      let incentives_message_set = false;
      
      for(let i = 0; i < threshold_items.length; i++){
        let threshold_amount = threshold_items[i].getAttribute('data-threshold');
        let threshold_label = threshold_items[i].getAttribute('data-label');
        let threshold_var_id = threshold_items[i].getAttribute('data-var-id');
        
        if(subtotal >= threshold_amount){
          
          threshold_items[i].classList.add('js-threshold-met');
          
        } else {
          
          threshold_items[i].classList.remove('js-threshold-met');
          if(!incentives_message_set){
            if(subtotal < threshold_amount){
              incentives_message_html = `Only $${((threshold_amount - subtotal)/100).toFixed(0)} away from <strong>${threshold_label}</strong>`;
              incentives_message_set = true;
            }
          }
          
        }
      }

      if(subtotal == 0){
        bar.style.width = "0%";
        message.innerHTML = `Free shipping for orders $${js_cart_incentives[0].threshold_USD / 100}+`;
      } else if(subtotal >= max_threshold){
        bar.style.width = "100%";
        message.innerHTML = `Wooble-yeah! <strong>FREE SHIPPING</strong> for you!`;
      } else {

        let threshold_width = 1 / js_cart_incentives.length * 100;
        for (let i = 0; i < js_cart_incentives.length; i++){

          if (subtotal < js_cart_incentives[0].threshold_USD) {
            // Below the first threshold

            waitForElement('#js-shipping-banner').then(shipping_banner => {
              if(subtotal == 0){
                // 0
                shipping_banner.innerHTML = `🚚 Free Shipping for orders $${js_cart_incentives[0].threshold_USD / 100}+`;
              } else {
                // less than threshold
                shipping_banner.innerHTML = `🚚 Spend $${(js_cart_incentives[0].threshold_USD - subtotal) / 100} more for Free Shipping`;
              } 
            }).catch();
            
            bar.style.width = `${(subtotal / js_cart_incentives[0].threshold_USD) * threshold_width}%`;
            break;
          } else if (subtotal > js_cart_incentives[i].threshold_USD && subtotal < js_cart_incentives[i + 1].threshold_USD) {
            // Between two thresholds

            waitForElement('#js-shipping-banner').then(shipping_banner => {
              shipping_banner.innerHTML = `🎉 Wooble-yeah! You get Free Shipping!`;
            }).catch();
            
            let threshold_size = js_cart_incentives[i+1].threshold_USD - js_cart_incentives[i].threshold_USD;
            let threshold_progress = (subtotal - js_cart_incentives[i].threshold_USD) / threshold_size;            
            bar.style.width = `${(i+1) * threshold_width + threshold_progress * threshold_width}%`;
            break;
          } else if (subtotal == js_cart_incentives[i].threshold_USD) {
            // totaling current threshold
            bar.style.width = `${(i+1) / js_cart_incentives.length * 100}%`;
            break;
          }
          
        }
        // bar.style.width = `${(subtotal/max_threshold)*100}%`;
        message.innerHTML = incentives_message_html;
      }

    }).catch(Woobles.Sentry.captureException);

  }).catch(Woobles.Sentry.captureException);

};

const cart_structutre_html = `
<style>
.js-hidden{
  display: none !important;
}

.js-row{
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
}

[class*="js-col"]{
  position: relative;
  padding: .25rem;
  height: 100%;
  min-width: 85px;
}

.js-col--80{
  width: 80%;
}

.js-col--75{
  width: 75%;
}

.js-col--66{
  width: 66.66%;
}

.js-col--50{
  width: 50%;
}

.js-col--33{
  width: 33.33%;
}

.js-col--25{
  width: 25%;
}

.js-col--20{
  width: 20%;
}

body.js-cart--open{
  overflow: hidden !important;
}

.js-cart--overlay{
  position: fixed;
  z-index: -1;
  pointer-events: none;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  transition: .5s ease all;
  background: #000;
  opacity: 0;
}

body.js-cart--open .js-cart--overlay{
  opacity: .5;
  z-index: 50;
  pointer-events: all;
}

.js-cart{
  overflow: auto;
  position: fixed;
  top: 0;
  left: -555px;
  height: 100%;
  max-width: 550px;
  width: 90%;
  background: #fff;
  z-index: 99; 
  transition: .5s ease all;
}

body .js-cart{
  left: auto;
  right: -555px;
}

body.js-cart--open .js-cart{
  right: 0;
}

.js-cart--button{
  display: block;
  border: 1px solid #ccc;
  padding: .5rem;
  cursor: pointer;
}

.js-cart--button:hover{
  background: #3a3a3a;
  border: 1px solid #3a3a3a;
  color: #fff;
}

.js-cart--info{
  display: flex;
  flex-direction: column;
}

.js-cart--title{
  font-size: 1.5rem;
  font-weight: 600;
  padding: 0.5rem 0;
}

.js-cart--item-count{
  font-weight: 400;
}

.js-cart--contents{
  width: 100%;
  flex: 1 1 auto;
  overflow-y: scroll;
  overflow-x: hidden;
}

.js-cart--totals{
  width: 100%;
  background: #eee;
  padding: .5rem;
}

.js-cart--controls{
  position: relative;
}
.js-cart--controls a.js-cart--close{
  display: block;
  position: absolute;
  top: .5rem; 
  right: 0;
  font-size: 1.5em;
  width: 1.5em;
  height: 1.5em;
  border-radius: 100%;
  border: 0;
  background: #eee;
  color: #999;
}

.js-cart--controls a.js-cart--close span{
  position: absolute; 
  top: 50%;
  left: 50%;
  transform: translate(-50%, -48.5%);
}

.js-cart--progress-bar{
  background: #009bbf;
  padding: .5rem;
}

@media(max-width: 768px){
  .js-cart--progress-bar .js-incentives{
    padding: 10px 20px;
  }
}

.js-cart--progress-bar .js-incentives--threshold--dot--icon{
  padding: 0 3px;
}

.js-cart--progress-bar .js-incentives--bar--filled{
  max-width: 100%;
}

.js-cart--line-items{}

.js-cart--subtotal,
.js-cart--savings,
.js-cart--shipping{
  position: relative;
  display: flex;
  width: 100%;
}

.js-cart--subtotal{
  font-weight: 600;
}

.js-cart--label{
  text-align: left;
}
.js-cart--value{
  text-align: right;
}

.js-cart--shipping .js-cart--value{
  font-size: .8em;
}

.js-cart--subtotal .js-cart--value{
  font-size: 16px;
}

.js-cart--checkout{
  position: block;
  text-align: center;
  font-weight: 600;
  font-size: 1.15em;
  padding: .5em;
  color: #fff;
  background: #3a3a3a;
  opacity: 1;
}

.js-cart--checkout:hover{
  opacity: .9;
  color: #fff;
}

.js-cart--line-item{
  position: relative;
  font-family: Poppins,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
  font-size: 1.1rem;
  line-height: 1.5rem;
  border-bottom: 1px solid #eee;
  padding-bottom: 0.5rem;
  margin-bottom: 0.5rem;
}

.js-cart--line-item{
  justify-content: space-between;
}

.js-cart--line-item--image{
  width: 100px;
}

.js-cart--line-item--image a{
  display: block;
  width: 100%;
  padding-bottom: 100%;
  height: 0;
  background-size: contain !important;
}

.js-cart--line-item--controls{
  position: relative;
}

a.js-cart--line-item--remove{
  display: block;
  position: absolute; 
  top: 0;
  right: 0;
  padding: 0;
  font-size: 1rem;
  font-weight: 400;
  width: 1.5rem;
  height: 1.5rem;
  border: 0;
  color: #999;
}

a.js-cart--line-item--remove:hover{
  color: #fff;
}

a.js-cart--line-item--remove span{
  position: absolute; 
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.js-cart--line-item--content{
  width: calc(100% - 100px);
  display: flex;
  flex-direction: column;
  min-height: 100px;
}

.js-cart--line-item--details{
  font-weight: 600;
  font-size: .9rem;
  flex: 1 1 auto;
}

.js-cart--line-item--details small{
  display: block;
  font-size: .85em;
  font-weight: 400;
}

.js-cart--line-item--totals{
  font-weight: 600;
  font-size: .85rem;
}

.js-cart--line-item--quantity{
  padding: 0;
}

.js-cart--line-item--quantity--decrement,
.js-cart--line-item--quantity--current,
.js-cart--line-item--quantity--increment{
  position: relative;
  display: inline-block;
  height: 2em;
  width: 2em;
  border: 1px solid #ccc;
  text-align: center;
}

.js-cart--line-item--quantity--decrement span,
.js-cart--line-item--quantity--current span,
.js-cart--line-item--quantity--increment span{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%)
}

.js-cart--line-item--quantity--current{
  width: 3.5em;
  margin: 0 -5px;
  border-left: 0;
  border-right: 0;
}

.js-cart--line-item--quantity--current span{
  font-size: .75em;
}

.js-cart--line-item--price{
  text-align: right;
  align-self: flex-end;
  font-size: 16px;
  font-weight: 600;
}

.js-cart--line-item--price s{
  opacity: .5;
}

.js-cart--line-item--discount{
  position: absolute;
  width: 100%;
  bottom: -0.75rem;
  right: 0;
  font-size: .7em;
  opacity: .5;
  white-space: nowrap;
  width: 50vw;
  max-width: 220px;
}

.js-cart--upsells{
  text-align: center;
  margin: 0 .5rem;
  overflow-y: scroll;
}

.js-cart--upsells--title{
  width: 100%;
}

.js-cart--upsell-item{
  background: #eee;
  padding: 0.5rem;
  margin: 1rem 0;
  border-radius: 5px;
  font-size: .8rem;
}

.js-cart--upsell-item--title{}

@media(max-width: 768px){

  .js-cart--upsells{
    width: 100%;
    height: auto;
  }

  .js-cart--upsells--container{
    overflow-x: scroll;
  }

  .js-cart--upsells--items{
    display: flex;
    margin: auto;
  }

  .js-cart--upsell-item{
    width: 140px;
    margin: 1rem 0.5rem;
  }

  .js-cart--upsell-item--title{
    display: block;
    min-height: 5em;
    line-height: 1.25em;
    padding: 0.5em;
  }
  
}

.js-cart--upsell-item--image{
  display: block;
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  background-size: contain !important;
}

.js-cart--upsell-item--atc{
  font-size: 0.8rem;
  padding: 0.5em;
  border-radius: 5px;
  font-weight: 600;
  background: #3a3a3a;
  border: 0 !important;
  color: #fff;
}

@media(max-width: 768px){
  .js-cart--structure{
    flex-wrap: wrap;
  }
  .js-cart--structure > [class*="js-col"]{
    width: 100%;
  }
  .js-cart--structure > [class*="js-col"]:first-child{
    order: 10;
  }
}

/* --- START INCENTIVES MODULE --- */
  
.js-incentives{
  background: #009bbf;
  color: #fff;
  padding: 18px 30px;
}

.js-incentives-mesage,
.js-incentives--message{
  font-size: 15px;
  text-align: center;
  margin-bottom: .5rem;
}

.js-incentives-mesage strong,
.js-incentives--message strong{
  font-weight: 600;
}

.js-incentives--bar{
  background: #0085A3;
  border-radius: 25px;
  height: 6px;
  position: relative;
  margin-bottom: 2rem;
}

@media (min-width: 769px) {
  .js-incentives--bar {
    margin-bottom: 2.5rem;
  }
}

.js-incentives--bar--filled{
  transition: .5s ease width;
  width: 10%;
  background: #fff;
  border-radius: 25px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
}

.js-incentives--goals{

}

.js-incentives--threshold{
  position: absolute;
  top: 0;
}

.js-incentives--threshold--dot{
  width: 18px;
  height: 18px;
  border-radius: 100%;
  background: #0085A3;
  position: absolute;
  top: -6px;
  left: -18px;
}

.js-incentives--threshold.js-threshold-met .js-incentives--threshold--dot{
  background: #fff;
}

.js-incentives--threshold--dot--icon{
  transition: .5s ease opacity;
  opacity: 0;
  padding: 3px;
}

.js-incentives--threshold.js-threshold-met .js-incentives--threshold--dot--icon{
  opacity: 1;
}

.js-incentives--threshold--dot--icon svg{
  width: 100%; 
  height: auto;
  fill: #009bbf !important;
}

.js-incentives--threshold--label{
  transition: .5s ease opacity;
  position: absolute;
  font-size: 11px;
  top: 16px;
  right: -30px;
  width: 100px;
  text-align: center;
  opacity: 0;
}

@media(max-width: 768px){
  .js-incentives--threshold--label {
    width: 120px;
    text-align: right;
    margin-right: 28px;
  }
}

.js-incentives--threshold.js-reveal .js-incentives--threshold--label,
.js-incentives--threshold.js-tease .js-incentives--threshold--label{
  opacity: 1;
}

.js-cart--line-item--details div {
    font-size: 75%;
    line-height: 1.75!important;
    font-weight: 500!important;
}
.js-cart--line-item--details div strong {
    font-weight: 500!important;
}
.js-cart--line-item--details {
    margin-bottom: 8px; 
}

.js-incentives:has(.new-accessory-subtext) {
  padding-bottom: 54px;
}

[data-label*="FREE ACCESSORY"] .js-incentives--threshold--label .new-accessory-subtext {
    width: 200%;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
}

</style>

<div class="js-cart--overlay"></div>
<div class="js-cart" data-item-count="" data-currency="" data-subtotal="" data-discount-total="" data-full-price="">
  
  <div class="js-row js-cart--structure">
    
    <div class="js-col--20 js-cart--upsells">
      <div class="js-cart--upsells--title"></div>
      <div class="js-cart--upsells--container">
        <div class="js-cart--upsells--items"></div>
      </div>
    </div>
    
    <div class="js-col--80 js-cart--info">

      <div class="js-cart--contents">
        <div class="js-cart--controls">
          <a class="js-cart--close js-cart--button">
            <span>&times;</span>
          </a>
        </div>

        <div class="js-cart--title">
          Cart <span class="js-cart--item-count"></span>
        </div>
        
        <div class="js-cart--progress-bar">
        
          ${js_cart_incentives_html}
        
        </div>
        
        <div class="js-cart--line-items"></div>

      </div>

      <div class="js-cart--totals">

        <div class="js-cart--shipping">
          <div class="js-col--50 js-cart--label">
            Shipping
          </div>
          <div class="js-col--50 js-cart--value">
            Free
          </div>
        </div>

        <div class="js-cart--savings js-hidden">
          <div class="js-col--50 js-cart--label">
            Discount
          </div>
          <div class="js-col--50 js-cart--value"></div>
        </div>

        <div class="js-cart--subtotal">
          <div class="js-col--50 js-cart--label">
            Subtotal
          </div>
          <div class="js-col--50 js-cart--value"></div>
        </div>
        <a href="/checkout" class="js-cart--checkout js-cart--button">Checkout</a>
      </div>

    </div>
  </div>

</div>
`;

observeSelector('.js-cart--overlay', off_modal => {
  off_modal.addEventListener("click", () => {
    close_js_cart();
  });
});

let js_cart_build_line_items = () => {
  console.log("js_cart_build_line_items()");

  // update the free shipping threshold (in case it was re-defined)
  free_shipping_threshold = js_cart_incentives[0].threshold_USD;

  
  if(free_shipping_threshold < 5000 && document.querySelectorAll('.js-cart--line-item').length > 0){
    // custom shipping threshold that is lower than the store's default shipping zone

    let last_cart_item = document.querySelectorAll('.js-cart--line-item')[document.querySelectorAll('.js-cart--line-item').length -1];
    let last_item_key = last_cart_item.getAttribute("data-key")
    let last_item_qty = last_cart_item.getAttribute("data-qty")
    
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: last_item_key,
        quantity: last_item_qty, 
        properties: { "_free shipping threshold": free_shipping_threshold / 100 }
      }),
    }).then(response => response.json()).then(cart => {
      console.log('Updated cart:', cart);
      retrieve_cart_data();
    }).catch((error) => {
      Woobles.Sentry.captureException(error);
      console.error('Error:', error);
    });
  }

  waitForElement('.js-cart--line-items').then(line_items_container => {
    // clear cart
    line_items_container.innerHTML = "";

    // get local cart data
    let local_cart_data = JSON.parse(window.sessionStorage.getItem("local-cart-data"))

    if(!local_cart_data){
      console.log("local_cart_data -- break", local_cart_data)
      return;
    } else {
      console.log("local_cart_data -- continue", local_cart_data)
    }

    // update cart data
    document.querySelector('.js-cart').setAttribute("data-item-count", local_cart_data.cart_item_count)
    document.querySelector('.js-cart--item-count').innerHTML = local_cart_data.cart_item_count;
    waitForElement('.js-cart-count').then(cart_count => {
      cart_count.innerHTML = local_cart_data.cart_item_count;
      cart_count.parentNode.classList.remove("hide");
    }).catch(Woobles.Sentry.captureException);

    document.querySelector('.js-cart').setAttribute("data-currency", local_cart_data.cart_currency)
    document.querySelector('.js-cart').setAttribute("data-subtotal", local_cart_data.cart_subtotal)
    document.querySelector('.js-cart--subtotal .js-cart--value').innerHTML = `$${(local_cart_data.cart_subtotal * 0.01).toFixed(2)}`; 

    if(local_cart_data.cart_subtotal >= free_shipping_threshold){
      document.querySelector('.js-cart--shipping .js-cart--value').innerText = "FREE";
    } else {
      if(typeof window.shipping_cost != "undefined"){
        document.querySelector('.js-cart--shipping .js-cart--value').innerText = window.shipping_cost;
      } else {
        document.querySelector('.js-cart--shipping .js-cart--value').innerText = "CALCULATED AT CHECKOUT"; 
      }
    }

    document.querySelector('.js-cart').setAttribute("data-discount-total", local_cart_data.cart_total_discount)
    document.querySelector('.js-cart--savings .js-cart--value').innerHTML = `$${(local_cart_data.cart_total_discount * 0.01).toFixed(2)}`;
    
    if(local_cart_data.cart_total_discount > 0){
      document.querySelector('.js-cart--savings').classList.remove("js-hidden");
    } else {
      document.querySelector('.js-cart--savings').classList.add("js-hidden");
    }
    
    document.querySelector('.js-cart').setAttribute("data-full-price", local_cart_data.cart_original_price)

    if(local_cart_data.cart_line_items.length > 0){

      let gift_cards_total = 0;
    
      // rebuild line items
      for(let i = 0; i < local_cart_data.cart_line_items.length; i++){

        // console.log("++++", local_cart_data.cart_line_items[i])

        let is_discounted_class = "js-hidden";
        let discount_title = "";
        if(local_cart_data.cart_line_items[i].original_line_price > local_cart_data.cart_line_items[i].final_line_price){
          is_discounted_class = "";
          discount_title = local_cart_data.cart_line_items[i].discounts[0].title;
        }

        let img_url_segments = local_cart_data.cart_line_items[i]?.featured_image?.url?.split('.') ?? [];
        let sm_img_url = "";
        for(let ii = 0; ii < img_url_segments.length; ii++){

          sm_img_url += img_url_segments[ii]

          if (ii == img_url_segments.length - 2) {
            sm_img_url += "_200x";
          } 
          
          if(ii < img_url_segments.length - 1){
            sm_img_url += ".";
          }

        }

        // New line item properties HTML with filter for "Hair" or "Skin"
        let line_item_properties_html = "";
        if(local_cart_data.cart_line_items[i].properties) {
          line_item_properties_html = Object.entries(local_cart_data.cart_line_items[i].properties)
            .filter(([key, value]) => key.includes("Hair") || key.includes("Skin"))
            .map(([key, value]) => {
              return `<div><strong>${key}:</strong> ${value}</div>`;
            }).join('');
        }       

        line_items_container.insertAdjacentHTML("afterbegin", `
        <div class="js-cart--line-item" data-var-id="${local_cart_data.cart_line_items[i].variant_id}" data-prod-id="${local_cart_data.cart_line_items[i].id}" data-qty="${local_cart_data.cart_line_items[i].quantity}" data-handle="${local_cart_data.cart_line_items[i].handle}" data-key="${local_cart_data.cart_line_items[i].key}" data-line-total="${local_cart_data.cart_line_items[i].final_line_price}">
          <div class="js-row">
            <div class="js-col js-cart--line-item--image">
              <a href="${local_cart_data.cart_line_items[i].url}" style="background: url(${sm_img_url}) no-repeat;"></a>
            </div>
            <div class="js-col js-cart--line-item--content">
              <div class="js-cart--line-item--details">
                <div class="js-cart--line-item--controls">
                  <a class="js-cart--line-item--remove js-cart--button" data-qty-change="0">
                    <span>&times;</span>
                  </a>
                </div>
                ${local_cart_data.cart_line_items[i].product_title}
                ${line_item_properties_html} <!-- Add line item properties here -->
              </div>
              <div class="js-row js-cart--line-item--totals">
                <div class="js-col--50 js-cart--line-item--quantity">
                  <div class="js-cart--line-item--quantity--decrement js-cart--button" data-qty-change="${local_cart_data.cart_line_items[i].quantity - 1}">
                    <span>&minus;</span>
                  </div>
                  <div class="js-cart--line-item--quantity--current">
                    <span>${local_cart_data.cart_line_items[i].quantity}</span>
                  </div>
                  <div class="js-cart--line-item--quantity--increment js-cart--button" data-qty-change="${local_cart_data.cart_line_items[i].quantity + 1}">
                  <span> &plus;</span>
                  </div>
                </div>
                <div class="js-col--50 js-cart--line-item--price">
                  <s class="${is_discounted_class}">$${(local_cart_data.cart_line_items[i].original_line_price * 0.01).toFixed(0)}</s> $${(local_cart_data.cart_line_items[i].final_line_price * 0.01).toFixed(0)}
                  <div class="js-cart--line-item--discount">${discount_title}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        `);

        console.log("doing stuff...", local_cart_data.cart_line_items[i].handle, gift_cards_total);
        if(local_cart_data.cart_line_items[i].handle.indexOf("gift-card") > -1){
          gift_cards_total += local_cart_data.cart_line_items[i].original_line_price; 
        }
        
        if(i == local_cart_data.cart_line_items.length - 1 || local_cart_data.cart_line_items.length == 0){
          // last loop or empty cart
          document.querySelector('.js-cart').setAttribute("data-gift-cards-total", gift_cards_total)
          
          js_cart_build_upsell_items();
          js_cart_update_progress_bar(local_cart_data.cart_subtotal - gift_cards_total);
          js_cart_build_gwp_items(local_cart_data.cart_subtotal - gift_cards_total);
        }
      }

    } else { // empyt cart
      js_cart_build_upsell_items();
      js_cart_update_progress_bar(0);
      js_cart_build_gwp_items(0);
    } // local_cart_data.cart_line_items.length > 0
    
  }).catch(Woobles.Sentry.captureException);

};

let open_js_cart = () => {
  waitForElement('body').then(() => {
    document.querySelector('body').classList.add('js-cart--open');
  }).catch(Woobles.Sentry.captureException);
};

let close_js_cart = () => {
  waitForElement('body').then(() => {
    document.querySelector('body').classList.remove('js-cart--open');
  }).catch(Woobles.Sentry.captureException);
};

if(getParam("cart") == "open" || window.location.href.indexOf("/cart") > -1){
  open_js_cart();
}

let js_cart_build_upsell_items = () => {
  console.log("js_cart_build_upsell_items()");

  waitForElement('.js-cart--upsells').then(upsells_container => {
    // clear upsells container
    upsells_container.querySelector('.js-cart--upsells--items').innerHTML = "";

    // remove any duplicates
    window.upsell_items_data = [...new Set(window.upsell_items_data)];

    // set from message price
    window.lowest_price_upsell_item = Math.min(...upsell_items_data.map(product => Number(parseInt(product.price))));
    upsells_container.querySelector('.js-cart--upsells--title').innerHTML = `Add Accessories from $${window.lowest_price_upsell_item / 100}`;
    
    // rebuild upsell items
    for(let i = 0; i < window.upsell_items_data.length; i++){
      if(document.querySelectorAll(`.js-cart--line-item[data-var-id="${window.upsell_items_data[i].var_id}"]`).length == 0){ 

        if(document.querySelectorAll(`.js-cart--upsell-item[data-var-id="${window.upsell_items_data[i].var_id}"]`).length == 0){ 
          // no duplicates
          upsells_container.querySelector('.js-cart--upsells--items').insertAdjacentHTML("beforeend", `
          <div class="js-cart--upsell-item" data-var-id="${window.upsell_items_data[i].var_id}">
            <div class="js-row">
              <div class="js-col">
                <a href="${window.upsell_items_data[i].pdp_url}" class="js-cart--upsell-item--image"style="background: url(${window.upsell_items_data[i].img_url});">
                </a>
                <a href="${window.upsell_items_data[i].pdp_url}" class="js-cart--upsell-item--title">
                ${window.upsell_items_data[i].title}
                </a>
                <a class="js-cart--upsell-item--atc js-cart--button" data-add-to-cart="${window.upsell_items_data[i].var_id}">
                  &plus; Add
                </a>
              </div>
            </div>
          </div>
          `); 
        }
      }
    }

    if(window.innerWidth < 768){
      document.querySelector('.js-cart--line-items').insertAdjacentElement("afterend", upsells_container);
      upsells_container.querySelector('.js-cart--upsells--items').style.width = `calc(140px * ${document.querySelectorAll('.js-cart--upsell-item').length})`;
    } else {
      upsells_container.querySelector('.js-cart--upsells--items').setAttribute('style', "");
    }

  }).catch(Woobles.Sentry.captureException);

};

window.addEventListener('resize', function() {

  if(window.innerWidth < 768){
    document.querySelector('.js-cart--line-items').insertAdjacentElement("afterend", document.querySelector('.js-cart--upsells'));
  } else {
    document.querySelector('.js-cart--info').insertAdjacentElement("beforebegin", document.querySelector('.js-cart--upsells'));
  }

});

let js_cart_build_gwp_items = (subtotal) => {
  console.log("js_cart_build_gwp_items()");

  // remove any GWP items from cart if already added
  for(let i = 0; i < window.hidden_products.length; i++){
    if(document.querySelectorAll(`.js-cart--line-item[data-var-id="${window.hidden_products[i].var_id}"]:not(.js-cart--gwp-free-item, [data-var-id="45487928672422"], [data-var-id="45922275426470"])`).length > 0){
      let item_to_remove = document.querySelector(`.js-cart--line-item[data-var-id="${window.hidden_products[i].var_id}"]`);
      let line_item_key = item_to_remove.closest('.js-cart--line-item').getAttribute("data-key");
      let line_item_qty = 0;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: line_item_key,
          quantity: line_item_qty, 
        }),
      }).then(response => response.json()).then(cart => {
        console.log('Updated cart:', cart);
        retrieve_cart_data();
      }).catch((error) => {
        Woobles.Sentry.captureException(error);
        console.error('Error:', error);
      });
    }
  }

  let gwp_checkout_params = "";
  
  // reset value
  window.gwp_items_to_add = [];
  window.gwp_items_to_add_ref = [];

  for(let i = 0; i < window.gwp_qualifying_items.length; i++){
    let gwp_qualifier_var_id = window.gwp_qualifying_items[i].var_id;
    let gwp_qualifier_threshold = 999999;
    if(!!window.gwp_qualifying_items[i].threshold){
     gwp_qualifier_threshold = window.gwp_qualifying_items[i].threshold;
    }
    if(document.querySelectorAll(`.js-cart--line-item[data-var-id="${gwp_qualifier_var_id}"]`).length > 0 || subtotal >= gwp_qualifier_threshold){

      let qty_of_gwp_qualifier = 1;
      if(subtotal < gwp_qualifier_threshold){
        qty_of_gwp_qualifier = document.querySelector(`.js-cart--line-item[data-var-id="${gwp_qualifier_var_id}"]`).getAttribute("data-qty");
      }
      for (let ii = 0; ii < parseInt(qty_of_gwp_qualifier); ii++) {
        window.gwp_items_to_add.push(window.gwp_qualifying_items[i].gwp_id);
        window.gwp_items_to_add_ref.push(i);
      }      

    }

    if(window.sessionStorage.getItem("woobles_sticker_pack_gwp") && subtotal > 0 && window.gwp_items_to_add.indexOf(14) == -1){
      console.log("stickers....");
      window.gwp_items_to_add.push(14);
    }

    if(i == window.gwp_qualifying_items.length -1 && window.gwp_items_to_add.length > 0){

      let gwp_items = {};
      for (let i = 0; i < window.gwp_items_to_add.length; i++) {
        let item = window.gwp_items_to_add[i];
        gwp_items[item] = (gwp_items[item] || 0) + 1;
      }

      let gwp_item_index = Object.keys(gwp_items);
      for (let i = 0; i < gwp_item_index.length; i++) {
        let hidden_item_index = gwp_item_index[i];
        let qty_to_add = gwp_items[hidden_item_index];

        let gwp_var_id = window.hidden_products[hidden_item_index].var_id;

        console.log("do gwp thing", window.gwp_items_to_add_ref[i])

        gwp_checkout_params += `items[][id]=${gwp_var_id}&items[][quantity]=${qty_to_add}&`;
        if(window.gwp_qualifying_items[window.gwp_items_to_add_ref[i]].threshold){
          gwp_checkout_params += `items[][properties][${encodeURIComponent("_free at threshold")}]=${parseInt(window.gwp_qualifying_items[window.gwp_items_to_add_ref[i]].threshold) / 100}&` 
        }

        document.querySelector('.js-cart--line-items').insertAdjacentHTML("afterbegin", `
          <div class="js-cart--line-item js-cart--gwp-free-item" data-var-id="${gwp_var_id}" data-qty="${qty_to_add}" data-handle="${window.hidden_products[hidden_item_index].handle}">
            <div class="js-row">
              <div class="js-col js-cart--line-item--image">
                <a style="background: url(${window.hidden_products[hidden_item_index].image}) no-repeat;"></a>
              </div>
              <div class="js-col js-cart--line-item--content">
                <div class="js-cart--line-item--details">
                  <div class="js-cart--line-item--controls"></div>
                  ${window.hidden_products[hidden_item_index].title}
                </div>
                <div class="js-row js-cart--line-item--totals">
                  <div class="js-col--50 js-cart--line-item--quantity">
                    <span>GET ${qty_to_add} FREE</span>
                  </div>
                  <div class="js-col--50 js-cart--line-item--price"></div>
                </div>
              </div>
            </div>
          </div>
        `);
      }

      document.querySelector('.js-cart--checkout').href = `/cart/add?${gwp_checkout_params}return_to=/checkout`;

    } else {
      document.querySelector('.js-cart--checkout').href = `/checkout`;
    }

  }

};

// handle qty adjustments
observeSelector('.js-cart--line-item [data-qty-change]', qty_change_button => {
  qty_change_button.addEventListener("click", () => {
    
    let line_item_key = qty_change_button.closest('.js-cart--line-item').getAttribute("data-key");
    let line_item_qty = qty_change_button.getAttribute("data-qty-change");
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: line_item_key,
        quantity: line_item_qty, 
      }),
    }).then(response => response.json()).then(cart => {
      console.log('Updated cart:', cart);
      retrieve_cart_data();
    }).catch((error) => {
      Woobles.Sentry.captureException(error);
      console.error('Error:', error);
    });
  });
});

// handle atc button clicks
observeSelector('[data-add-to-cart], [class*="add-to-cart"]', atc_button => {
  atc_button.addEventListener("click", () => {
    Woobles.Sentry.addClickBreadcrumb({
      message: 'Clicked Add to Cart - [data-add-to-cart]',
      data: {
        html: atc_button.outerHTML
      }
    })

    if(!!atc_button.getAttribute("data-add-to-cart")){
      let var_id = atc_button.getAttribute("data-add-to-cart");
      let props = {};

      for (key in atc_button.dataset) {
        if (key.startsWith('properties') && atc_button.dataset[key].split(":").length > 1) {
          const [prop_name, prop_value] = atc_button.dataset[key].split(":");
          props[prop_name.trim()] = prop_value.trim();
        }
      }

      add_to_cart(var_id, 1, props);
    } else {
    setTimeout(() => {
      open_js_cart();
      retrieve_cart_data();
    }, 500);
  }

  });
});

observeSelector('button, a', button => {
  if(button.innerText.toLowerCase().indexOf("add") > -1 ||
    button.innerText.toLowerCase().indexOf("cart") > -1 || 
    button.innerText.toLowerCase().indexOf("pick 4 kits") > -1){
    button.addEventListener("click", () => {
      if(button.innerText.toLowerCase().indexOf("address") == -1 && window.location.href.indexOf("/account") == -1){
        setTimeout(() => {
          open_js_cart();
          retrieve_cart_data();
        }, 1500); 
      }
    });
  }
})

window.addEventListener('local_cart_data_updated', () => {
  console.log("EVENT: local_cart_data_updated");
  js_cart_build_line_items();
});

let js_cart_init = () => {
  console.log("js_cart_init()");
  waitForElement('body').then(doc => {
    // doc.classList.add("js-cart--open")
    doc.insertAdjacentHTML("afterbegin", cart_structutre_html);
    js_cart_build_line_items(); // from local storage
    retrieve_cart_data();
  }).catch(Woobles.Sentry.captureException);
};

js_cart_init();

waitForElement('body').then(doc => {
  doc.insertAdjacentHTML("afterbegin", `
  <div id="js-shipping-banner" class="js-shipping-banner" style="
    background: #009bbf;
    padding: .5rem 1rem;
    color: #fff;
    font-weight: 500;
    text-align: center;
  ">🚚 Free Shipping for orders $${parseInt(js_cart_incentives[0].threshold_USD/100)}+</div>
  `);
}).catch(Woobles.Sentry.captureException);

// clicks of checkout on /cart page (standard checkout button does not process GWPs)
if(window.location.href.indexOf(".com/cart") > -1){
  waitForElement('input[type="submit"][name="checkout"]').then(standard_checkout_btn => {
    standard_checkout_btn.addEventListener("click", (e) => {
      e.preventDefault();
      waitForElement('.js-cart--checkout').then(js_cart_checkout_btn => {
        js_cart_checkout_btn.click();
      })
    });
  }).catch(Woobles.Sentry.captureException);
}